import { Navigate, useLocation } from 'react-router';
import useAuthContext from '@/features/auth/_shared/contexts/auth.context';
import { memo } from 'react';
import { Spinner } from '@/components/_ui/spinner';
import { APP_ROUTES } from '@/app/app.route.constants';

interface PublicRouteProps {
  children: React.ReactNode;
}

export const PublicRoute = memo(({ children }: PublicRouteProps) => {
  const { isAuthenticated, hydrated, state } = useAuthContext();

  // Wait for hydration before deciding
  if (!hydrated || state?.loading) {
    return (
      <div className="flex justify-center items-center flex-1 h-screen">
        <Spinner className="h-[40px] w-[40px]" />
      </div>
    );
  }

  // If not authenticated, redirect to login
  if (isAuthenticated) {
    return <Navigate to={APP_ROUTES.app.root.path} replace />;
  }

  return children;
});

PublicRoute.displayName = 'PublicRoute';
